import React from 'react';
import { bindActionCreators } from 'redux';
import { Circles } from "../../common/loadingComponent";
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import { parseQuery } from '../../../store/apiWrapper';
import { searchActions } from '../../../store/searchStore';
import { withLocalize } from 'react-localize-redux';
import { withRouter } from 'react-router';
import NoDataComponent from "../../common/noDataComponent";
import Paging from "../../common/pagingComponent";
import Section from "../../common/businessBulletinSection";

import '../../../css/search/search.scss';

class BusinessBulletinSearchResult extends React.Component {
    render() {
        const data = isNullOrUndefined(this.props.search.searchResult) ? null : this.props.search.searchResult.data;
        const isSearching = isNullOrUndefined(this.props.search) ? false : this.props.search.isSearching;

        if (isSearching)
            return <Circles />;

        if (isNullOrUndefined(data) || isNullOrUndefined(data.items) || data.items.length === 0) {
            return (
                <NoDataComponent />
            )
        }

        const entityId = this.getEntityId(this.props);
        const found = data.found || 0;
        const page = this.props.search.searchPaging.page;
        const pageSize = this.props.search.searchPaging.count;

        return (
            <>
                <div className='card card-special' style={{ fontSize: "0.875em" }}>
                    <div className="card-body">
                        {data.items.map((item) =>
                            <Section level={2} key={item.rowNum} rowNum={item.rowNum} bulletinId={item.id} name={`${(item.dateFormated)} ${isNullOrUndefined(item.name) ? "" : item.name}`}>
                                { }
                            </Section>
                        )}
                    </div>
                </div>
                {this.renderPaging(entityId, found, page, pageSize)}
            </>
        )
    }

    componentDidMount() {
        const data = this.getSearchParams();
        const entityId = this.getEntityId(this.props);

        if (!isNullOrUndefined(data) || !isNullOrUndefined(entityId))
            this.props.getBusinessBulletin(entityId, data, this.props.search.searchPaging);
    }

    componentDidUpdate(prevProps, _prevState) {
        if (this.props.search.isSearching)
            return;

        const data = this.getSearchParams();
        const entityId = this.getEntityId(this.props);

        if ((!isNullOrUndefined(entityId) && !isEqual(this.getEntityId(prevProps), entityId))) {
            this.props.endBulletinsSearch();
            this.props.getBusinessBulletin(entityId, data, this.props.search.searchPaging);
        }
        else if (this.props.search.languageChanged) {
            this.props.getBusinessBulletin(entityId, data, this.props.search.searchPaging);
        }
    }

    componentWillUnmount() {
        this.props.endBulletinsSearch();
    }

    getSearchParams() {
        const historyData = !isNullOrUndefined(this.props.history) && !isNullOrUndefined(this.props.history.location) ? this.props.history.location.state : undefined;
        return isNullOrUndefined(this.props.location.state) ? historyData : this.props.location.state;
    }

    getEntityId(props) {
        return isNullOrUndefined(props.location.search) ? null : parseQuery(props.location.search).entityId;
    }

    renderPaging = (entityId, totalCount, page, pageSize) => {
        return (page && Math.ceil(totalCount / pageSize) > 1) ? (
            <div className="paging-wrapper">
                <Paging selectedPage={page}
                    totalPages={Math.ceil(totalCount / pageSize)}
                    setPage={p => {
                        this.props.changePageBulletin(entityId, p);
                    }} />
            </div>
        ) : null;
    }
}

export default withRouter(withLocalize(connect(
    state => ({ ...state, search: state.search }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(BusinessBulletinSearchResult)));
